import React from 'react';
import { Column, EditType } from '@src/model/table';
import { TableDescriptionCell } from '@src/components/shared/table-description-cell/table-description-cell';
import { validateString } from '@src/utils/validationUtils';
import { checkIP } from '@src/utils/ipValidationUtil';
import { sortByIpHex } from '@src/utils/sort-util';
import { CustomerStore } from '@src/components/store/customer.store';
import { ActionType, AddressIPType, getCustomEnumOptions } from '@src/utils/enums';
import CustomIcon, { IconType } from '@src/components/shared/custom-icon/custom-icon';
import { toCamelCase } from '@src/utils/string-normalization';

export function createDescriptionColumn<T extends {description: string}>(width: number, maxLength = 1000): Column<T> {
    return {
        accessor: 'description' as keyof T & string,
        header: 'Description',
        width: `${width}px`,
        displayOnEdit: true,
        type: EditType.TextArea,
        getPlaceholder: () => 'Add Description',
        maxLength,
        getDisplayElement: (column, row: T) => <TableDescriptionCell rowData={row}/>,
        validationRules: [(value) => validateString(value, false)]
    };
}

export function createIPAddressColumn<T>(customerStore: CustomerStore, width = 400): Column<T> {
    return {
        accessor: 'value' as keyof T & string,
        header: 'IP Address',
        width: `${width}px`,
        type: EditType.IP,
        displayOnEdit: true,
        getPlaceholder: () => 'IP Address',
        validationRules: [(value) => checkIP(value, customerStore.selectedLocation?.ipv6Supported)],
        mandatory: true,
        isKeyField: true,
        showDuplicatedError: true,
        isSortable: true,
        sortFn: (a: any, b: any, direction: 'asc' | 'desc') => sortByIpHex('value', a, b, direction),
    };
}

export function createIPTypeColumn<T>(): Column<T> {
    return {
        accessor: 'ipType' as keyof T & string,
        header: 'Type',
        width: '150px',
        displayOnEdit: true,
        type: EditType.Dropdown,
        options: () => getCustomEnumOptions(AddressIPType),
        mandatory: true
    };
}

export function createDomainActionColumn<T extends {domainAction: string}>(): Column<T> {
    return {
        accessor: 'domainAction' as keyof T & string,
        header: 'Action',
        width: '150px',
        displayOnEdit: true,
        type: EditType.Dropdown,
        options: () => getCustomEnumOptions(ActionType),
        getDisplayElement: (column, row) =>
            <div className={'action-cell-content'}>
                <CustomIcon className={row.domainAction.toLowerCase()}
                            type={row.domainAction === ActionType.ALLOW ? IconType.ALLOW_ICON : IconType.BLOCK_ICON}/>
                <div className={`action ${row.domainAction.toLowerCase()}`}>{toCamelCase(row.domainAction)}</div>
            </div>,
        mandatory: true
    };
}


